"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Checkbox_1 = __importDefault(require("../../../Checkbox"));
var Tabs_1 = require("../../../Tabs/Tabs");
exports.errorKeys = ['applied_for', 'applied_for_other'];
var options = [
    'small_fridge',
    'large_fridge_freezer',
    'small_fridge_freezer',
    'washing_machine',
    'other',
];
var WhiteGoodsForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _h = formik_1.useFormikContext(), values = _h.values, errors = _h.errors;
    var _j = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.white_goods) || {}), formErrors = _j[0], setFormErrors = _j[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.white_goods) || {}); }, [
        (_c = errors.project) === null || _c === void 0 ? void 0 : _c.white_goods,
    ]);
    var appliedFor = values.project.white_goods.applied_for || [];
    return (react_1.default.createElement(__1.Card, { heading: trans('optiiva::headings.white-goods'), subHeading: trans('optiiva::headings.project') },
        react_1.default.createElement(__1.FormControl, { errors: (_e = (_d = errors.project) === null || _d === void 0 ? void 0 : _d.white_goods) === null || _e === void 0 ? void 0 : _e.applied_for, label: trans('project:slhh::labels.applied-for'), flush: true, showOther: appliedFor.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.white_goods) === null || _g === void 0 ? void 0 : _g.applied_for_other, label: trans('project:slhh::labels.applied-for-other') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.white_goods.applied_for_other", maxLength: 5000 })) },
            react_1.default.createElement("div", { className: "flex flex-col" }, options.map(function (key) { return (react_1.default.createElement(Checkbox_1.default, { key: "applied_for." + key, name: "project.white_goods.applied_for", label: trans("project:slhh::enum.white-goods." + key), value: key })); })))));
};
exports.default = WhiteGoodsForm;
//# sourceMappingURL=WhiteGoodsForm.js.map